import "./Loader.css";
import logo from "../../assets/loader.gif";
const Loader = () => {
 return (
  <div className="loader-container">
   <img src={logo} alt="logo" />
  </div>
 );
};

export default Loader;
